import AxiosConfig from '../../../config/AxiosConfig';

const useUpdateOrderStatus = ({ order }) => {
  const updateStatus = async ({
    statusCode,
    userId,
    note,
    ticketId,
    stateToLock,
  }) => {
    try {
      const payload = {
        statusCode,
        userId,
        note: note || '',
        ticketId: ticketId || null,
        stateToLock: stateToLock || null,
      };

      let updatedOrder;
      try {
        await AxiosConfig.create('put', `/orders/${order?._id}/status/`)
        .call(payload)
          .exit((res) => (updatedOrder = res?.data));
      } catch (error) {
        const messageError =
          error?.response?.data?.errorMessage ||
          error?.response?.data?.message ||
          `Error: ${error?.response?.status || ''} - ${error?.response?.statusText || ''}: updateStatus`;
        throw new Error(messageError);
      }

      return updatedOrder;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut:', error);
      throw error;
    }
  };

  return { updateStatus };
};

export default useUpdateOrderStatus;
